export const getIpaddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org/?format=json");
    if(response?.status === 200){
      const result = await response?.json();
      return result;
    }else{
      return false;
    }

  } catch (error) {
    return false;
  }
};
